import { Sistema } from "../models/sistema";

export const Sistemas:readonly Sistema[] = [{
    nome: "Login",
    desc: "Sistema de Autenticação.",
    linkStag: "https://login-hml.ciadofrete.com.br/",
    linkProd: "https://login.ciadofrete.com.br/",
    inativo: true,
    old: false
  },{
    nome: "Sistemas",
    desc: "Lista de Sistemas.",
    linkStag: "https://sistemas-hml.ciadofrete.com.br/",
    linkProd: "https://sistemas.ciadofrete.com.br/",
    inativo: true,
    old: false
  },{
    nome: "Sistema ERP",
    desc: "Sistema de Controle Financeiro.",
    linkStag: "https://erp-hml.ciadofrete.com.br/",
    linkProd: "https://erp.ciadofrete.com.br/",
    inativo: false,
    old: false
  },{
    nome: "Próximo Sistema",
    desc: "Aqui vai ser o próximo sistema.",
    linkStag: "https://-hml.ciadofrete.com.br/",
    linkProd: "https://.ciadofrete.com.br/",
    inativo: true,
    old: false
  },];

